import { TDO_GRID_COLUMN_WIDTH } from '@helpers/constants';
import { LAST_MODIFIED_DATE, MainPageStore } from './models';
import { clamp } from 'lodash';

/**
  interface TemporalDataObject {
    id: ID!
    name: String
    thumbnailUrl: String
    createdDateTime: DateTime
    modifiedDateTime: DateTime
    details: null | { tags: null | Array<{ value: IN_REDACTION_TAG_KEY; redactionStatus: string; redactionStatusKey?: string }> };
    primaryAsset: {
      id: ID
      signedUri: string
    }
    assets: { records: {}[] }
    engineRuns: {
      hasUserEdits: boolean;
      status: pending | running | complete | queued | accepted | failed | cancelled | standby_pending | waiting | resuming | aborted
      engine: { category: { iconClass: string }}
    }
  }
*/

// calculate number of items per page
const MIN_ITEMS_PER_PAGE = 12;
const MAX_ITEMS_PER_PAGE = 48;
const FETCH_BLOCK = clamp(
  Math.floor(window.innerWidth / TDO_GRID_COLUMN_WIDTH) *
    Math.ceil(window.innerHeight / TDO_GRID_COLUMN_WIDTH),
  MIN_ITEMS_PER_PAGE,
  MAX_ITEMS_PER_PAGE
);

// /**
//  * Default state constant,
//  *
//  * @const MainPageStore
//  */
export const defaultState: MainPageStore = {
  sdos: {},
  tdos: {},
  selectedTDOs: {},

  currentPage: 1,
  invalidSDOCount: 0,
  sdoOffset: 0,
  itemsPerPage: FETCH_BLOCK,
  hasMore: false,
  loadingNextPage: false,

  filter: LAST_MODIFIED_DATE,

  fetchingOrganizationTdos: false,
  loaded: false,

  error: undefined,

  isFilePickerOpen: false,
  isFilePickerUrlOpen: false,

  // use for update UI when create tdo success and createJob Ingestion running/fail
  // if createJob ingestion success, this variable will not be used
  listTDOsUploading: {},
  newlyAddedTdoIds: [],
  lastOpenedTdoId: undefined,
  homeListStale: false,
};

export const namespace = 'vtn-redact-state-mainPage';

export interface RedactMainPageState {
  [namespace]: MainPageStore;
}
